var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "checkout-modal",
      attrs: {
        centered: "",
        id: "checkOutModal",
        title: "Check-Out",
        "hide-footer": "",
      },
    },
    [
      _c("b-form", [
        _c("p", [
          _vm._v(
            "The pre-authorizated credit card hold of $" +
              _vm._s(_vm.amount) +
              " will expire automatically 24 hours after check-out."
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mt-4" }, [
          _vm._v(
            "To capture all or a portion of the hold please visit your stripe portal."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mx-0 mt-2" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  staticClass: "my-2 px-3",
                  attrs: { variant: "danger" },
                  on: { click: _vm.checkOut },
                },
                [_vm._v("\n        Check-Out\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }